export default {"src":"/_next/static/media/amex.6ba5b930.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};